// yield delay(1000)
export function delay(ms) {
    return new Promise(resolve => setTimeout(() => resolve(true), ms));
}
//# sourceMappingURL=delay.js.map